export function convertDateFromStringIfNeeded(value: string | Date): Date {
    if (typeof value === "string") {
        return new Date(value);
    }
    return value;
}
